import { USE_MOCKS } from '@/lib/mocks';
import { TabsRemoteConfigDatasource } from '../data/datasources/tabs-remote-config.datasource';
import { TabsConfigRepositoryImpl } from '../data/repositories/tabs-config.repository.impl';

/**
 * Com mocks, sem Remote Config: o `useTabsConfig` liga todas as abas, para o
 * desenvolvimento local não depender do console.
 */
export const tabsConfigContainer = {
  repository: USE_MOCKS
    ? null
    : new TabsConfigRepositoryImpl(new TabsRemoteConfigDatasource()),
};
